var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9501 9.375C21.7501 4.425 17.3251 0.75 12.0001 0.75H11.6251V9.375H22.9501ZM6.37505 2.25C3.75005 3.7875 1.80005 6.3375 1.05005 9.375H6.37505V2.25ZM1.05005 14.625C1.80005 17.6625 3.75005 20.2125 6.37505 21.75V14.625H1.05005ZM11.6251 23.25H12.0001C17.3251 23.25 21.7501 19.575 22.9501 14.625H11.6251V23.25Z",
    fill: "#428BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.95 9.375H11.625V0.75C9.7125 0.825 7.9125 1.35 6.375 2.25V9.375H1.05C0.8625 10.2 0.75 11.1 0.75 12C0.75 12.9 0.8625 13.8 1.05 14.625H6.375V21.75C7.9125 22.65 9.7125 23.175 11.625 23.25V14.625H22.95C23.1375 13.8 23.25 12.9 23.25 12C23.25 11.1 23.1375 10.2 22.95 9.375Z",
    fill: "#FFE62E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.b0ee20cf34cb87b51f29d8e9cacea631.svg";
export { ForwardRef as ReactComponent };